var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99978 7.29471V6.24094C8.00406 6.06866 7.94475 5.90082 7.8331 5.76933C7.51834 5.39857 6.43878 5.16142 6.01085 5.2525C5.6773 5.32351 5.44389 5.65842 5.21572 5.88615C4.33458 5.38608 3.605 4.65797 3.10396 3.77853C3.33213 3.55083 3.66773 3.31792 3.73888 2.985C3.83 2.55858 3.59316 1.48591 3.22496 1.16988C3.09544 1.05872 2.92985 0.998354 2.75904 1.00003H1.70315C1.30083 1.00041 0.966118 1.36126 1.00275 1.7658C0.999998 5.2525 3.72224 8 7.2325 7.99724C7.6392 8.03395 8.00141 7.69756 7.99978 7.29471Z",
    stroke: "#3E4159",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47168 2.36084C5.75837 2.41677 6.04292 2.5432 6.24946 2.74973C6.456 2.95626 6.58242 3.24083 6.63835 3.52751",
    stroke: "#3E4159",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66699 1C6.26258 1.06617 6.79854 1.3543 7.22255 1.77778C7.64655 2.20125 7.9334 2.73782 8.00033 3.33333",
    stroke: "#3E4159",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e17e95dc70935fffeeddf055b0453c3f.svg";
export { ForwardRef as ReactComponent };